import axios from "axios";
import { config } from "../config";
import reduxStore from "redux/store";
import { showErrorMessage } from "redux/actions/commonActions";
import { updateLoading } from "redux/actions/commonActions";

const headers = {
	"Content-Type": "application/json",
};

const instance = axios.create({
	baseURL: config.apiUrl,
	headers,
	// timeout: 1000,
	// headers: {'Content-Type': 'application/json','Accept':'application/json'}
});


const username = 'Tawn';
const password = 'Tawn$2030';
const base64Credentials = btoa(`${username}:${password}`);
export const instanceWithEncryption = axios.create({
	baseURL: config.apiUrl,
	headers: {
		'Content-Type': 'application/json',
		'Accept':'application/json',
		"Authorization": `Basic ${base64Credentials}`
	}
});

const requestHandler = (request) => {
	// request.data = encryptService(JSON.stringify(request.data));
	return request;
};


instance.interceptors.request.use(requestHandler);

const isSuccess = (data) => {
	return (
		data &&
		((data.resultCode && data.resultCode === "S") ||
			//Note: Required For Visit Visa APIs
			(data.status &&
				(data.status === "1" ||
					data.status == "Success" ||
					data.status == "S")) ||
			(data.status && data.status === "1") ||
			(data && data.GetBeneficariesDetailsResult))
	);
};

const getErrorMessage = (data) => {
	if (data.resultCode) {
		return data.resultMessage;
	}
	if (data.status) {
		if (data.resultDesc) {
			return data.resultDesc;
		}
		if (data.statusDescritpion) {
			return data.statusDescritpion;
		}
		if (data.errorDesc) {
			return data.errorDesc;
		}
	}
};

const responseHandler = (response) => {
	if (!isSuccess(response.data)) {
		return errorHandler({ message: getErrorMessage(response.data) });
	}
	return response;
};

const errorHandler = (error) => {
	reduxStore.dispatch(updateLoading(false));
	if (error.message.includes("/policyNo")) {
	} else if (error.message.includes("/policyNo")) {
		reduxStore.dispatch(
			showErrorMessage("We Could Not Connect, Please Try Again Later")
		);
	} else {
		reduxStore.dispatch(showErrorMessage(error.message));
	}

	setTimeout(() => {
		reduxStore.dispatch(showErrorMessage(""));
	}, 500);
	return Promise.reject(error);
};

// instance.interceptors.request.use(requestHandler,errorHandler);
// instance.interceptors.response.use(responseHandler,errorHandler);

export default instance;
